import Favorite from '@@types/Favorite';
import FolderFavorite from '@@types/FolderFavorite';

import { favoritesStore } from '~/stores/FavoritesStore';

class FavoriteMessageHandler {
  handleCreate = (favorite: Favorite) => {
    favoritesStore.addFavorite(favorite);
  };

  handleRemove = (favorites: any) => {
    favoritesStore.setFavorites(favorites);
  };

  handleNameUpdate = (favorite: FolderFavorite) => {
    favoritesStore.updateFolder(favorite.id, favorite);
  };

  handleUpdateOrder = (favorites: any) => {
    favoritesStore.setFavorites(favorites);
  };
}

export default FavoriteMessageHandler;
